import { MutationKey, useMutation, UseMutationOptions } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { HttpException, resolveHttpErrorMessage } from '../exceptions/index';

type AppMutationProps<
  TData = unknown,
  TError = HttpException,
  TVariables = void,
  TContext = unknown,
> = {
  defaultErrorHandling?: boolean;
} & Omit<UseMutationOptions<TData, TError, TVariables, TContext>, 'mutationKey'>;

export const useAppMutation = <
  TData = unknown,
  TError = HttpException,
  TVariables = void,
  TContext = unknown,
>(
  mutationKey: MutationKey = [],
  { defaultErrorHandling = true, ...params }: AppMutationProps<TData, TError, TVariables, TContext>,
) =>
  useMutation({
    mutationKey,
    ...params,
    onError: (error, variables, context) => {
      if (defaultErrorHandling && error instanceof HttpException) {
        toast(resolveHttpErrorMessage(error), {
          position: 'bottom-center',
          type: 'error',
          theme: 'light',
        });
      }

      params.onError?.(error, variables, context);
    },
  });
